import React from "react";
import { Chip, Tooltip } from "@material-ui/core";

interface StatusStyle {
    label: string;
    background: string;
    color: string;
    description: string;
}

const STATUS_STYLES: Record<string, StatusStyle> = {
    Applied: {
        label: "Applied",
        background: "#ecfdf5",
        color: "#047857",
        description: "Changes have been synchronized with the device.",
    },
    Syncing: {
        label: "Syncing...",
        background: "#eff6ff",
        color: "#1d4ed8",
        description: "Synchronizing changes with the device. Waiting for confirmation.",
    },
    Deferred: {
        label: "Pending",
        background: "#fef3c7",
        color: "#b45309",
        description: "The device saw this change but is waiting for a safe moment to apply it (e.g. hardware busy).",
    },
    Failed: {
        label: "Failed",
        background: "#F7E1E0",
        color: "#c62828",
        description: "The device tried to apply these changes and reported an error.",
    },
    Unreachable: {
        label: "Awaiting hardware",
        background: "#f1f5f9",
        color: "#64748b",
        description: "The device hasn't reported a status for this section yet.",
    },
};

const DEFAULT_STYLE: StatusStyle = STATUS_STYLES.Unreachable;

interface Props {
    status?: string | null;
    reason?: string | null;
}

export const SectionStatusChip: React.FC<Props> = ({ status, reason }) => {
    const style = (status && STATUS_STYLES[status]) || DEFAULT_STYLE;
    const tooltipTitle = reason ? `${style.description} ${reason}.` : style.description;

    return (
        <Tooltip title={tooltipTitle}>
            <Chip
                size="small"
                label={style.label}
                style={{ backgroundColor: style.background, color: style.color, fontWeight: 500 }}
            />
        </Tooltip>
    );
};
